import axios from 'axios';

const axiosClient = axios.create({
    headers: {
        'X-CSRF-Token': window.csrfTokenValue,
        'X-Requested-With': 'XMLHttpRequest'
    },
})

export default axiosClient;
